/**
 * This abstract dialog is shown when a user performs an action on a
 * scheduled update either from the sidebar or from an individual field
 *
 * @author Manoj Kintali (mkintali@yext.com), Kevin Wang (kwang@yext.com)
 */
goog.module('yext.scheduledupdates.dialog.ActionDialog');
goog.module.declareLegacyNamespace();

const yext = goog.require('yext');
const dialog = goog.require('yext.dialog');
const routes = goog.require('yext.scheduledupdates.routes');
const MultiSelect = goog.require('yext.ui.MultiSelect');
const Option = goog.require('yext.ui.MultiSelect.Option');

/**
  * Constructor for the ScheduledUpdateActionDialog
  *
  * @param {string} date                      The date of scheduled updates you're operating on
  * @param {string=} opt_selectedFieldId       Which field we should select by default
  * @param {string=} opt_selectedCustomFieldId Which field we should select by default
  * @param {!jQuery} $dialog              The jqueryObject representing the dialog
  *
  * @constructor
  */
const ActionDialog = function(date, opt_selectedFieldId, opt_selectedCustomFieldId, $dialog) {
  this.$dialog = $dialog;
  this.date = date;
  this.selectedFieldId = opt_selectedFieldId || null;
  this.selectedCustomFieldId = opt_selectedCustomFieldId || null;
  this.multiSelect = new MultiSelect({
    'showSelectAll': true,
    'selectAllCallback': this.selectAllCallback()});

  this.bindOptionChecked();
};

/**
 * Callback function to run when all options are selected
 */
ActionDialog.prototype.selectAllCallback = function() {
  var self = this;
  return function() {
    self.$dialog.find('.js-scheduled-fields').html(self.multiSelect.$el);
    self.checkEnableSubmit();
  };
};

ActionDialog.prototype.bindOptionChecked = function() {
  var self = this;
  $(this.multiSelect).on('option.changed', function() {
    self.checkEnableSubmit();
  });
};

/**
 * Check whether the submit button for the dialog should be enabled or disabled
 */
ActionDialog.prototype.checkEnableSubmit = function() {
  if (this.multiSelect.getCheckedOptions().length > 0) {
    this.$dialog.find('.js-submit-btn').prop('disabled', false);
  } else {
    this.$dialog.find('.js-submit-btn').prop('disabled', true);
  }
};

/**
 * Generates the multiselect part of the dialog
 *
 * @param {!Array.<MultiSelect.Option>}  options   The options you want to use to generate the multiselect
 * @returns {string} HTML of the multi select
 */
ActionDialog.prototype.getMultiSelectBody = function(options) {
  // Figure out which fields need to be checked by default
  var self = this;
  options.forEach(function(option) {
    if (!self.selectedFieldId && !self.selectedCustomFieldId) {
    // If the action request isn't for a specific field then
    // select all fields by default.
      option.setChecked(true);
    } else if (self.selectedFieldId === option.id) {
      option.setChecked(true);
    } else if (self.selectedFieldId.indexOf('virtual.expanded.') !== -1
        && self.selectedFieldId.indexOf(option.id) !== -1) {
      option.setChecked(true);
    } else if (('customField-' + self.selectedCustomFieldId) === option.id) {
      option.setChecked(true);
    }
  });

  // Initialize the multiselect with those options.
  this.multiSelect.init(options);
  return this.multiSelect.$el.html();
};

/**
 * Makes an ajax request to figure out which fields we want to display on the dialog.
 * @returns Object containing {!Array.<MultiSelect.Option>} and errors
 */
ActionDialog.prototype.getFieldOptions = function() {
  var fieldOptions = {options: []};
  var self = this;
  var url = routes.getFieldsForAction();
  url = url + window.location.search + '&futureDate=' + encodeURIComponent(self.date);

  $.ajax({
    url: url,
    type: 'GET',
    success: function(result) {
      result.options.forEach(function(option) {
        var optionModel = new MultiSelect.Option();
        optionModel.id = option.id;
        optionModel.label = option.label;
        fieldOptions.options.push(optionModel);
      });
    },
    error: function() {
      fieldOptions.error = true;
    },
    async: false,
  });
  return fieldOptions;
};

/**
 * Loads the correct page after a successful cancel/reschedule operation.
 * If the operation was for all fields on the future date that we're currently on,
 * it should refresh to today's date, same page otherwise
 */
ActionDialog.prototype.loadNextPage = function() {
  var self = this;
  setTimeout(function() {
    if (yext.getUrlParam('date') === self.date && self.multiSelect.isAllOptionsChecked()) {
      var params = yext.getUrlParams();
      delete params.date;
      window.location.href = yext.buildUrlWithParams(window.location.href.split('?')[0], params);
    } else {
      window.location.reload(true);
    }
  }, 2000);
};

exports = ActionDialog;
